export default {
  selectedSource: 'knowledge-base',
  defaultSource: 'knowledge-base',
  sourcesSiteId: null,
  sourcesRequestId: 0,
  genieAvailable: false,
  chatAgents: [],
  sourcesLoading: false,
  conversations: [],
  activeConversationId: null,
  messagesByConversationId: {},
  loadedConversationIds: {},
  isLoadingConversations: false,
  isLoadingActiveConversation: false,
  isStreaming: false,
  abortController: null,
  activeRequestId: null,
  activeBackend: null,
  error: null,
};
